import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext.tsx';

export default function IsNotLoggedIn() {
  const { isAuthenticated, isLoading, isSuperUser, user } = useAuth();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  if (isAuthenticated) {
    // SU usa /dashboard como landing minimal (sólo saludo). El usuario normal
    // (MVP) vuelve a su flujo elegido (backend), o a la home para elegirlo.
    if (isSuperUser) return <Navigate to="/dashboard" replace />;
    return <Navigate to={user?.chosenFlow ? `/${user.chosenFlow}` : '/'} replace />;
  }

  return <Outlet />;
}
